import { css } from 'styled-components';

import { BaseStyle } from '@nhl/nhl-breakaway-ui';

import { SIZES } from './styles';

export const matchupColumnStyle = css`
    // need to set max-width so we can apply "space-between" to the entire row
    ${BaseStyle.Mixins.screenSizes.large} {
        max-width: ${SIZES.teamMatchup.size}px;
    }

    ${BaseStyle.Mixins.screenSizes.extraLarge} {
        max-width: none;
    }
`;

export const gameNumberAndDateColumnStyle = css`
    ${BaseStyle.Mixins.screenSizes.large} {
        max-width: ${SIZES.gameNumberAndDate.size}px;
    }

    ${BaseStyle.Mixins.screenSizes.extraLarge} {
        max-width: none;
    }
`;
